/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'
import type { ActionTypes as DetailActionTypes } from '../../reducers/types'
import { unitsReducer } from './reducers/index'
import { whitelist } from './reducers/whitelist'

export const units = filterActions<
  ReturnType<typeof unitsReducer>,
  DetailActionTypes,
  (typeof whitelist)[number]
>(unitsReducer, whitelist)
